import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OneXButton from "../OneX/OneXButton";
import {
  staticAppConfig,
} from "../AppData/Recoil";
import { useMedia } from "use-media";
import OneXSpecs from "../OneX/OneXSpecs";

const Error = () => {
  const [init, setInit] = useState(false);

  let navigate = useNavigate();

  const isMobile = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.MOBILE);
  const isTablet = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.TABLET);
  const isDesktop = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.DESKTOP);

  useEffect(() => {
    if(!init) {
      setInit(true);
    }
  }, [init, navigate]);

  const handleContinue = () => {
    navigate(staticAppConfig.routes.landing);
  }

  return(
    <div
      id={"auth"}
      className={"-oneX-col-lg-7 -oneX-col-md-8 -oneX-col-sm-10"}
      style={{
        marginBottom: "224px"
      }}
    >

      <h1 id={`auth-header`} style={{ marginTop: isDesktop ? "56px" : isTablet ? "48px" : isMobile ? "40px" : "40px", marginBottom: "50px" }}>
        Sorry, we're having technical issues.
      </h1>
      <p
        className="-oneX-body--intro"
        role="alert"
        aria-live="assertive"
        aria-label="There was a technical error. Please call 888-559-1922 for help. State Farm Bank® customers, call 877-SF4-BANK (2265)"
        style={{ marginBottom: "37px" }}
      >
        Please call{" "}
        <a href="tel:888-550-1922" class="-oneX-link--block">
          888-559-1922
        </a>{" "}
        for help.
        .
      </p>


      <div style={{ marginBottom: "23px" }}>
        <OneXButton
          id={"errorHomeBtn"}
          clickHandler={handleContinue}
        >
          Home
        </OneXButton>
      </div>
    </div>
  )
}

export default Error;